import { Typography } from '@surveycake/rc';
import React, { FunctionComponent, ReactElement } from 'react';
import { SlateHtmlProps } from '../SlateHtml';
import { useStyles } from './styles';

export interface IntroProps {
  title?: string;
  children?: ReactElement<SlateHtmlProps>;
}

const Intro: FunctionComponent<IntroProps> = ({ title, children }) => {
  const classes = useStyles([Boolean(title)]);
  return (
    <div className={classes.intro} aria-label="intro">
      {title && (
        <Typography variant="h4" color="primary" gutterBottom>
          {title}
        </Typography>
      )}
      {children}
    </div>
  );
};

export default Intro;
